<template>
  <div class="rego-search">
    <div class="header d-flex justify-content-center">
      <div class="header-content">
        <img
          src="@/assets/images/logo_header_new.svg"
          @click="$router.go()"
          class="cursor-pointer"
        />
      </div>
    </div>
    <div
      class="
        rego-search-content
        d-flex
        justify-content-center
        align-items-center
        position-relative
      "
    >
      <div class="inner">
        <div class="wrapper d-flex justify-content-between align-items-center">
          <div class="callout text-white">
            <p class="title">Sell your wholesale car</p>
            <p class="desc">
              The team at AutoFlip will find you the best price for your
              wholesale car
            </p>
          </div>
          <div class="right-content-rego text-left">
            <p class="fs-24 mb-2 right-title-rego">
              <b>The best price for your car starts here!</b>
            </p>
            <span class="fs-14 font-weight-thin">
              Get started by entering your car details here
            </span>
            <div class="position-relative">
              <custom-select
                label="State"
                v-model="regoSearchInfo.state"
                :options="stateOptions"
                :error="$v.regoSearchInfo.state.$error"
                :class="{
                  error: $v.regoSearchInfo.state.$error,
                  'shadow-none mt-35': true,
                }"
              />
              <p
                v-if="
                  $v.regoSearchInfo.state.$dirty &&
                  !$v.regoSearchInfo.state.required
                "
                class="msg-error mb-0"
              >
                <i>Please select state</i>
              </p>
            </div>
            <div class="position-relative">
              <float-label label="Rego">
                <b-input
                  v-model.trim="regoSearchInfo.regoNumber"
                  placeholder="Enter rego"
                  autocomplete="off"
                  required
                  @keyup.enter="submit"
                  :class="{
                    error: $v.regoSearchInfo.regoNumber.$error,
                    'shadow-none mt-27': true,
                  }"
                />
              </float-label>
              <p
                v-if="
                  $v.regoSearchInfo.regoNumber.$dirty &&
                  !$v.regoSearchInfo.regoNumber.required
                "
                class="msg-error mb-0"
              >
                <i>Please enter rego number</i>
              </p>
              <p
                v-else-if="
                  $v.regoSearchInfo.regoNumber.$dirty &&
                  !$v.regoSearchInfo.regoNumber.alphaNum
                "
                class="msg-error mb-0"
              >
                <i>Please enter only alphabet characters and numerics</i>
              </p>
              <p
                v-else-if="
                  $v.regoSearchInfo.regoNumber.$dirty &&
                  !$v.regoSearchInfo.regoNumber.maxLength
                "
                class="msg-error mb-0"
              >
                <i>Please enter 1 to 9 characters!</i>
              </p>
            </div>
            <div class="row justify-content-between">
              <div class="item col-5">
                <button
                  @click="goTo"
                  class="outline-btn-skip btn-skip fs-16 text-success"
                >
                  <span class="font-weight-regular">Skip rego</span>
                </button>
              </div>
              <div class="item col-7">
                <button
                  @click="regoSearch"
                  :disabled="isLoadingApi"
                  :class="[
                    activeBtnGo ? 'active-btn-go' : 'default-btn-go',
                    'btn-go fs-16 text-white',
                  ]"
                  ref="searchButton"
                >
                  <b class="font-weight-regular" v-if="!isLoadingApi"
                    >Let's go</b
                  >
                  <b-spinner
                    v-else
                    label="Loading..."
                    class="btn-loading"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="position-relative">
              <p class="mb-0 msg-api api-loading" v-if="isLoadingApi">
                <i>Searching for your vehicle</i>
              </p>
              <p
                class="text-center mb-0 msg-api api-not-found"
                v-if="apiNotFound & !isLoadingApi"
              >
                <i>No results</i>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="wave position-absolute"></div>
    </div>
  </div>
</template>

<script>
import { required, maxLength, alphaNum } from "vuelidate/lib/validators";
import topPageService from "@/services/top-page";
import { ACTION_REGO_SEARCH, ACTION_SET_RB_LOOKUP_FLAG } from "@/store/rego-search/actions";
import { SET_REGO_SEARCH_FLAG } from "@/store/info/actions";
import FloatLabel from "./FloatLabel";
import { LP_TYPE } from "@/config";
import CustomSelect from "./CustomSelect";
import { logError } from "@/helper/utils";

export default {
  name: "RegoSearch",
  data() {
    return {
      regoSearchInfo: {
        regoNumber: null,
        state: null,
        leadSource: LP_TYPE,
      },
      isLoadingApi: false,
      apiNotFound: false,
    };
  },
  methods: {
    goTo() {
      this.$router.push({ name: "vehicle-info", query: this.$route.query });
    },
    submit() {
      this.regoSearch();
    },
    async regoSearch() {
      this.$v.regoSearchInfo.$touch();
      if (!this.$v.regoSearchInfo.$invalid) {
        this.isLoadingApi = true;
        try {
          const seachResult = await topPageService.searchRego(
            this.regoSearchInfo
          );
          this.isLoadingApi = false;
          if (seachResult.status === 201) {
            seachResult.data.location = this.regoSearchInfo.state;
            seachResult.data.rego = this.regoSearchInfo.regoNumber.toUpperCase();
            this.$store.dispatch(SET_REGO_SEARCH_FLAG, true);
            this.$store.dispatch(ACTION_SET_RB_LOOKUP_FLAG, true);
            this.$store
              .dispatch(ACTION_REGO_SEARCH, seachResult.data)
              .then(() => {
                this.$router.push({ name: "vehicle-info", query: this.$route.query });
              });
          }
        } catch (err) {
          this.isLoadingApi = false;
          this.apiNotFound = true;
          if (err.response.status === 404) {
            this.$toast.warning(
              "We were unable to find your car information via our Rego search. Please fill in the information below."
            );
            this.$store.dispatch(ACTION_SET_RB_LOOKUP_FLAG, true);
            this.$store
              .dispatch(ACTION_REGO_SEARCH, {
                location: this.regoSearchInfo.state,
                rego: this.regoSearchInfo.regoNumber.toUpperCase(),
              })
              .then(() => {
                this.$router.push({ name: "vehicle-info", query: this.$route.query });
              });
          } else {
            logError(`Rego search error: ${err}`);
          }
        }
      }
    },
  },
  validations: {
    regoSearchInfo: {
      regoNumber: {
        required,
        alphaNum,
        maxLength: maxLength(9),
      },
      state: {
        required,
      },
    },
  },
  computed: {
    stateOptions: function () {
      return [null, "ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA"];
    },
    activeBtnGo: function () {
      return (
        this.regoSearchInfo.regoNumber &&
        this.regoSearchInfo.state &&
        !this.$v.regoSearchInfo.regoNumber.$error &&
        !this.$v.regoSearchInfo.state.$error
      );
    },
  },
  mounted() {
    let regoInfo = this.$store.getters.regoSearch;
    if (Object.keys(regoInfo).length > 0) {
      this.regoSearchInfo.regoNumber = regoInfo.rego;
      this.regoSearchInfo.state = regoInfo.location;
    }

  },
  components: {
    FloatLabel,
    CustomSelect,
  },
};
</script>

<style lang="scss">
.rego-search {
  text-align: initial;

  .header {
    padding: 1rem;
    background-color: #fff;
    height: 56px;

    @media screen and (min-width: 768px) {
      padding: 1rem 1rem;
      height: 80px;
    }

    .header-content {
      width: 100%;
      max-width: 1386px;
      height: 48px;

      @media screen and (min-width: 768px) {
        width: 88%;
      }
    }

    img {
      width: 157px;
      max-height: 30px;
      height: auto;

      @media screen and (min-width: 768px) {
        width: 250px;
        max-height: 48px;
        height: 48px;
      }
    }
  }

  .rego-search-content {
    background-image: url("~@/assets/images/bg_top_page.png");
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: cover;

    @media screen and (min-width: 768px) {
      height: calc(100vh - 180px);
      background-position: top;
    }

    .inner {
      width: calc(100vw - 2rem);
      padding: 15px 0;

      @media screen and (min-width: 768px) {
        position: absolute;
        width: calc(100vw - 60px);
        max-width: 1386px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        z-index: 1;
      }

      .wrapper {
        flex-direction: column;
        @media screen and (min-width: 768px) {
          flex-direction: row;
          width: 88%;
          margin: 0 auto !important;

          @media (orientation: portrait){
            flex-direction: column;
          }
        }

        .callout {
          .title {
            text-align: center;
            font-size: 30px;
            font-weight: 700;
            margin-bottom: 0;

            @media screen and (min-width: 768px) {
              text-align: left;
              flex-direction: row;
              font-size: 62px;
              line-height: 75px;
              
              @media (orientation: portrait){
                text-align: center;
                white-space: nowrap;
              }
            }
          }

          .desc {
            font-size: 20px;
            text-align: center;
            margin-bottom: 0;

            @media screen and (min-width: 768px) {
              text-align: left;

              @media (orientation: portrait){
                text-align: center;
                margin-bottom: 50px;
              }
            }

            @media (orientation: portrait){
              text-align: center;
              margin-bottom: 50px;
            }
          }
        }

        .right-content-rego {
          max-width: 490px;
          padding: 25px 30px 40px;
          background-color: #ffffff;
          border-radius: 20px;
          z-index: 1;

          @media screen and (min-width: 768px) {
            // width: 50%;
            z-index: unset;

            @media (orientation: portrait){
              transform: scale(1.2);
            }
          }

          .right-title-rego {
            color: #292644;
            line-height: 24px;
          }

          input,
          select {
            color: #383c3f;
            height: 50px;
            font-size: 16px;
            font-weight: bold;
            line-height: 21.6px;
            padding-left: 20px;
            padding-right: 10px;
            background-color: #ffffff !important;
            border-radius: 10px;

            &:focus {
              box-shadow: none;
            }
          }

          .label-input {
            color: #999999;
            top: -10px;
            left: 10px;
            padding-left: 10px;
            padding-right: 14px;
            background-color: #ffffff;
          }

          .no-rego {
            color: #b3b3b3;
            width: fit-content;
            text-decoration: underline;
            margin: 2px 0 9px auto;
          }

          .btn-go {
            width: 100%;
            height: 50px;
            margin-top: 20px;
            border: none;
            border-radius: 10px !important;

            &:focus {
              outline: none;
            }

            &:disabled {
              background-color: #00b86d !important;
            }
          }

          .btn-skip {
            width: 100px;
            height: 50px;
            margin-top: 20px;
            border: none;
            border-radius: 10px !important;
            @media screen and (min-width: 768px) {
              width: 170px;

              @media (max-device-width: 1200px) and (orientation: landscape){
                width: 125px;
              }
            }

            &:focus {
              outline: none;
            }

            &:disabled {
              background-color: #00b86d !important;
            }

            &:hover {
              background-color: #00b86d;
            }

            &:hover span {
              color: #ffffff;
            }
          }

          .default-btn-go {
            background-color: #cccccc;

            &:hover {
              background-color: #4ad295;
            }
          }

          .active-btn-go {
            background-color: #00b86d;
          }

          .outline-btn-skip {
            background-color: #ffffff;
            border: 1px solid #00b86d !important;
          }

          .btn-loading {
            font-size: 16px;
            width: 30px;
            height: 30px;
          }

          input.error {
            caret-color: #c1272d;
            border-color: #c1272d !important;
          }

          .msg-error {
            font-size: 12px;
            color: #c1272d;
            text-align: right;
            white-space: nowrap;
            margin-top: 2px;
          }

          .msg-api {
            position: absolute;
            font-size: 14px;
            line-height: 16.8px;
            top: 2px;
          }

          .api-loading {
            right: 0;
            color: #00b86d;
          }

          .api-not-found {
            color: #c1272d;
            right: 0;
          }
        }
      }
    }

    .wave {
      bottom: 0;
      width: 100%;
      height: 266px;
      background-image: url("~@/assets/images/wave.svg");
      background-repeat: no-repeat;
      background-position: bottom;
      background-size: cover;
    }
  }
}
</style>
